/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon24Solid = forwardRef('ArrowDRadiusDownLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19 4.5a7.5 7.5 0 0 1-7.5 7.5H5.772L9.81 7.96a1.5 1.5 0 1 0-2.122-2.12l-5.185 5.185a3.5 3.5 0 0 0 0 4.95l5.185 5.186a1.5 1.5 0 0 0 2.122-2.122L5.77 15h5.73C17.298 15 22 10.299 22 4.5v-1a1.5 1.5 0 0 0-3 0v1Z" })));
});
